const popups = {};

export function registerPopup(name, fn) {
    popups[name] = fn;
}

export function registerPopups(popupDefs) {
    Object.assign(popups, popupDefs);
}

export function getPopup(name) {
    return popups[name];
}
